import Cookies from "js-cookie";

const FORCE_LOGIN_FOR_PLUS_CHECKOUT = "ab_test_force_login_to_purchase_plus";

const NAV_CTA_COOKIE = "ab_test_nav_cta";
const CTA_VARIANTS = ["demo", "call", "none"];

const COOKIE_OPTS = { path: "/", expires: 60 };

// If missing, assign cookies with a 50/50 split.
function getOrAssignAbCookie(name) {
  let cookieValue = Cookies.get(name);
  if (cookieValue === undefined) {
    // 50% split.
    cookieValue = Math.random() < 0.5 ? "true" : "false";
    Cookies.set(name, cookieValue, COOKIE_OPTS);
  }
  return cookieValue === "true";
}

// Set ab test cookies for the first time
export function setAbTestCookies() {
  if (typeof document === "undefined") return;
  getCtaVariant();
  getOrAssignAbCookie(FORCE_LOGIN_FOR_PLUS_CHECKOUT);
}

/**
 * ACTIVE A/B TESTS BELOW
 *
 * Split (when the cookie is first assigned): ab_test:nav_cta — ~33% each: none, demo, call.
 * ab_test:force_login_to_purchase_plus — 50% true, 50% false.
 *
 * | Cookie                               | Value | Outcome                                                |
 * |--------------------------------------|-------|--------------------------------------------------------|
 * | ab_test:nav_cta                      | none  | No nav CTA                                             |
 * | ab_test:nav_cta                      | demo  | Demo CTA                                               |
 * | ab_test:nav_cta                      | call  | "Ring upp mig" CTA                                    |
 * | ab_test:force_login_to_purchase_plus | true  | Logged-out users must log in before checkout modal     |
 * | ab_test:force_login_to_purchase_plus | false | Checkout modal available while logged out              |
 */

// A/B test: Show navigation CTA - demo, call, or none.
export function getCtaVariant() {
  const ctaVariantCookie = Cookies.get(NAV_CTA_COOKIE);
  if (ctaVariantCookie && CTA_VARIANTS.includes(ctaVariantCookie)) {
    return ctaVariantCookie;
  }

  // 33% split between demo, call, and none.
  const randomIndex = Math.floor(Math.random() * CTA_VARIANTS.length);
  const randomCta = CTA_VARIANTS[randomIndex];
  Cookies.set(NAV_CTA_COOKIE, randomCta, COOKIE_OPTS);
  return randomCta;
}

// A/B test: force login to purchase plus. Handling authenticated users as well.
export function forceLoginToPurchasePlus(isLoggedIn) {
  const cookie = getOrAssignAbCookie(FORCE_LOGIN_FOR_PLUS_CHECKOUT);
  if (isLoggedIn === undefined) {
    return cookie;
  }
  return cookie && !isLoggedIn;
}
